class ExternalAssetsController {

    constructor() {

        // Plantillas
        this._chooseFromTemplate = null;
        this._catalogueTemplate = null;
        this._catalogueResultsTemplate = null;
        this._suggestionsTemplate = null;

        // Datos
        this._externalAssetsData = new ExternalAssetsData();
        this._onSelectImageCallback = null;
        this._onCancelImageCallback = null;

        this._loadTemplates();

    }

    _loadTemplates() {

        this._chooseFromTemplate = Handlebars.compile($("#chooseImageFromModal").html());
        this._catalogueTemplate = Handlebars.compile($("#catalogueScreen").html());
        this._catalogueResultsTemplate = Handlebars.compile($("#catalogueResults").html());
        this._suggestionsTemplate = Handlebars.compile($("#imageSuggestionsModal").html());

    }

    _enableChooseFromModalHandlers() {

        $("div.option-box-button.my-device").on("click.fromMyDevice", this._onUploadFromDevice.bind(this));
        $("div.option-box-button.catalogue").on("click.fromCatalogue", this._onUploadFromCatalogue.bind(this));
        $("#choose-image-from-modal input.upload-image").on("input.change", this._onSelectDeviceImage.bind(this));
        $("body.modal-open").on("click.outsideModal", this._onCloseChooseFromModal.bind(this));

    }

    _enableCatalogueScreenHandlers() {

        $(".catalogue-section div.back-button").on("click.closeCatalogue", this._onCloseCatalogue.bind(this));
        $(".catalogue-section img.clear-button").on("click.clearSearch", this._onClearSearch.bind(this));
        $(".catalogue-section div.tag-item").on("click.changeTopic", this._onChangeTopic.bind(this));
        $(".catalogue-section div.image-list").on("click.selectImage", "div.image", this._onSelectCatalogueImage.bind(this));
        $(".catalogue-section p.toggle-topics-button").on("click.toggleTopics", this._onToggleTopicsButton.bind(this));
        $("#image-searcher-form").on("submit.search", this._onSearch.bind(this));
        $(window).on("scroll.moreImages", this._onScrollBottom.bind(this));

    }

    _enableSuggestionsModalHandlers() {

        $("#image-suggestions-modal div.modal-close-btn").on("click.closeSuggestions", this._onCloseSuggestions.bind(this));
        $("#image-suggestions-modal div.image-list").on("click.selectImage", "div.image", this._onSelectCatalogueImage.bind(this));
        $("#image-suggestions-modal div.modal-footer").on("click.refreshImages", this._onRefreshImages.bind(this));

    }

    _disableChooseFromModalHandlers() {
        $("body.modal-open").off("click.outsideModal");
    }

    _disableCatalogueScreenHandlers() {
        $(window).off("scroll.moreImages");
    }

    _onUploadFromDevice(event) {

        const $uploadInput = $("#choose-image-from-modal input.upload-image");
        $uploadInput.trigger("click.openFileChooser");

    }

    _onScrollBottom(event) {

        function _onGetDataSuccess(response) {

            if (api.checkisValidResult(response)) {

                const $imageList = $(".catalogue-section div.image-list");
                const context = {
                    photos: response.result.photos
                }

                // Por coherencia el catalogo de fotos aumenta pero a la hora de dibujarlo solo pinto los nuevos elementos
                that._externalAssetsData.addCataloguePhotos(response.result.photos);
                $imageList.append(that._catalogueResultsTemplate(context));

            }

        }

        const that = this;
        const windowHeight = $(window).height();
        const catalogueSectionHeight = $(".catalogue-section")[0].scrollHeight;
        const currentScrollPosition = $(window).scrollTop();

        if (currentScrollPosition >= catalogueSectionHeight - windowHeight) {

            this._externalAssetsData.setPage(this._externalAssetsData.getCurrentPage() + 1);

            if (!this._externalAssetsData.getIsSearchByTerm() && !this._externalAssetsData.getIsSearchByTopic()) {

                api.getPhotos(this._externalAssetsData.getCurrentPage(), this._externalAssetsData.getIsSortedByPopularity(), _onGetDataSuccess);

            } else if (this._externalAssetsData.getIsSearchByTopic()) {

                const $topicSelected = $(".topic-tags > div.tag-item.selected");
                const topicId = $topicSelected.data("id");

                api.getTopicPhotos(this._externalAssetsData.getCurrentPage(), topicId, _onGetDataSuccess);

            } else {

                const $searchInput = $("input.image-searcher-input");
                const searchTerm = $searchInput.val().trim();

                api.searchPhotos(this._externalAssetsData.getCurrentPage(), searchTerm, _onGetDataSuccess);

            }

        }

    }

    _onUploadFromCatalogue(event) {

        function _onGetDataSuccess(response) {

            if (api.checkisValidResult(response)) {

                if (response.result.topics) {
                    that._externalAssetsData.setCatalogueTopics(response.result.topics);
                } else {
                    that._externalAssetsData.setCataloguePhotos(response.result.photos);
                }

                if (that._externalAssetsData.getCatalogueTopics() && that._externalAssetsData.getCataloguePhotos()) {
                    that._drawCatalogueScreen();
                }

            }

        }

        const $modalContainer = $("#modalContainer");
        const that = this;

        api.getTopics(_onGetDataSuccess);
        api.getPhotos(this._externalAssetsData.getCurrentPage(), this._externalAssetsData.getIsSortedByPopularity(), _onGetDataSuccess);

        $modalContainer.modal("hide").empty();

    }

    _onCloseCatalogue(event) {

        const $quizWrapper = $(".quiz-wrapper");

        // Se cierra desde el boton (no al seleccionar la imagen)
        if (event) {

            if (this._onCancelImageCallback) {
                this._onCancelImageCallback();
                this._onCancelImageCallback = null;
            }

        }

        baseController.closeStack();
        $quizWrapper.removeClass("white-background");

        this._externalAssetsData.clearData();
        this._disableCatalogueScreenHandlers();

        goUpController.stop();

    }

    _onCloseSuggestions(event) {

        const $modalContainer = $("#modalContainer");

        // Se cierra desde el boton (no al seleccionar la imagen)
        if (event) {

            if (this._onCancelImageCallback) {
                this._onCancelImageCallback();
                this._onCancelImageCallback = null;
            }

        }

        $modalContainer.modal("hide").empty();
        this._externalAssetsData.clearData();
        this._disableCatalogueScreenHandlers();

    }

    _onCloseChooseFromModal(event) {

        const $this = $(event.target);

        if ($this.hasClass("modal")) {

            if(!$this.closest('#choose-image-from-modal').length && !$this.is('#choose-image-from-modal')) {

                const $modalContainer = $("#modalContainer");

                if (this._onCancelImageCallback) {
                    this._onCancelImageCallback();
                    this._onCancelImageCallback = null;
                }

                $modalContainer.modal("hide").empty();
                this._externalAssetsData.clearData();
                this._disableChooseFromModalHandlers();

            }

        }

    }

    _onClearSearch(event) {

        const $searchForm = $("#image-searcher-form");
        const $searchInput = $("input.image-searcher-input");

        $searchInput.val("");
        $searchForm.trigger("submit.search");

    }

    _onSearch(event) {

        function _onGetDataSuccess(response) {

            if (api.checkisValidResult(response)) {

                const $imageList = $(".catalogue-section div.image-list");
                const context = {
                    photos: response.result.photos
                }

                that._externalAssetsData.setCataloguePhotos(response.result.photos);

                $imageList.html(that._catalogueResultsTemplate(context));

            }

        }

        event.preventDefault();

        const $searchInput = $("input.image-searcher-input");
        const $clearInputButton = $("img.clear-button");
        const that = this;
        const searchTerm = $searchInput.val().trim();

        // Resetear la pagina a la primera
        this._externalAssetsData.setPage(0);

        // Limpiar el buscador de imagenes por topic
        if (this._externalAssetsData.getIsSearchByTopic()) {

            const $lastTopicSelected = $(".topic-tags > div.tag-item.selected");

            $lastTopicSelected.removeClass("selected world_color_1_bg");
            this._externalAssetsData.setSearchByTopic(false);

        }

        if (searchTerm.length > 0) {

            $clearInputButton.show();
            this._externalAssetsData.setSearchByTerm(true);
            api.searchPhotos(this._externalAssetsData.getCurrentPage(), searchTerm, _onGetDataSuccess)

        } else {

            $clearInputButton.hide();
            this._externalAssetsData.setSearchByTerm(false);
            api.getPhotos(this._externalAssetsData.getCurrentPage(), this._externalAssetsData.getIsSortedByPopularity(), _onGetDataSuccess);

        }

    }

    _onChangeTopic(event) {

        function _onGetDataSuccess(response) {

            if (api.checkisValidResult(response)) {

                const $imageList = $(".catalogue-section div.image-list");
                const context = {
                    photos: response.result.photos
                }

                that._externalAssetsData.setCataloguePhotos(response.result.photos);
                $imageList.html(that._catalogueResultsTemplate(context));

            }

        }

        const $this = $(event.currentTarget);
        const $lastTopicSelected = $(".topic-tags > div.tag-item.selected");
        const that = this;
        const topicId = $this.data("id");

        // Resetear la pagina a la primera
        this._externalAssetsData.setPage(0);

        // Limpiar el buscador de imagenes por termino
        if (this._externalAssetsData.getIsSearchByTerm()) {

            const $searchInput = $("input.image-searcher-input");
            const $clearInputButton = $("img.clear-button");

            $searchInput.val("");
            $clearInputButton.hide();

            this._externalAssetsData.setSearchByTerm(false);

        }

        if ($this.hasClass("selected")) {
            this._externalAssetsData.setSearchByTopic(false);
            $this.removeClass("selected world_color_1_bg");
            api.getPhotos(this._externalAssetsData.getCurrentPage(), this._externalAssetsData.getIsSortedByPopularity(), _onGetDataSuccess);
        } else {
            this._externalAssetsData.setSearchByTopic(true);
            $lastTopicSelected.removeClass("selected world_color_1_bg");
            $this.addClass("selected world_color_1_bg");
            api.getTopicPhotos(this._externalAssetsData.getCurrentPage(), topicId, _onGetDataSuccess);
        }

    }

    _onToggleTopicsButton(event) {

        const $topicTags = $("div.topic-tags");
        const $toggleTopicsButton = $("p.toggle-topics-button");
        const collapseToHeight = 80;
        const expandToHeight = $topicTags[0].scrollHeight;

        if ($topicTags.hasClass("expanded")) {
            $topicTags.animate({height: collapseToHeight});
            $topicTags.removeClass("expanded");
            $toggleTopicsButton.text(Translator.trans("TR_VER_TODOS_LOS_TEMAS"));
        } else {
            $topicTags.animate({height: expandToHeight});
            $topicTags.addClass("expanded");
            $toggleTopicsButton.text(Translator.trans("TR_VER_MENOS"));
        }

    }

    _onSelectDeviceImage(event) {

        const that = this;
        const file = $(event.currentTarget)[0].files[0];
        const reader = new FileReader();

        reader.onloadend = function() {

            const $modalContainer = $("#modalContainer");
            $modalContainer.modal("hide").empty();

            if (that._onSelectImageCallback) {
                that._onSelectImageCallback({base64: true, url: reader.result});
                that._onSelectImageCallback = null;
            }

            that._disableChooseFromModalHandlers();

        };

        reader.readAsDataURL(file);

    }

    _onSelectCatalogueImage(event) {

        function _onUploadSuccess(response) {

            if (api.checkisValidResult(response)) {

                const $suggestionsModal = $("#image-suggestions-modal");

                if ($suggestionsModal.length > 0) {
                    that._onCloseSuggestions();
                } else {
                    that._onCloseCatalogue();
                }

                if (that._onSelectImageCallback) {
                    that._onSelectImageCallback({base64: false, url: response.result});
                    that._onSelectImageCallback = null;
                }

            }

        }

        const $this = $(event.currentTarget);
        const that = this;
        const photoId = $this.data("id");
        const photoUrl = $this.data("url");

        api.uploadSelectedImage(photoId, photoUrl, _onUploadSuccess);

    }

    _onRefreshImages(event) {

        function _startRefreshAnimation() {
            $refreshIcon.attr("class", "icon refresh");
        }

        function _stopRefreshAnimation() {
            $refreshIcon.attr("class", "icon");
        }

        function _onGetDataSuccess(response) {

            if (api.checkisValidResult(response)) {

                const $imageList = $("#image-suggestions-modal div.image-list");
                const context = {
                    photos: response.result.photos
                }

                that._externalAssetsData.setCataloguePhotos(response.result.photos);
                $imageList.html(that._catalogueResultsTemplate(context));

            }

        }

        const that = this;
        const $refreshIcon = $(".modal-footer > svg.icon");

        _startRefreshAnimation();
        setTimeout(_stopRefreshAnimation, 200);

        api.getRandomPhotos(this._externalAssetsData.getSuggestionsTerm(), this._externalAssetsData.getNumberOfSuggestions(), this._externalAssetsData.getDocumentType(), _onGetDataSuccess);

    }

    _drawChooseFromModal() {

        const $modalContainer = $("#modalContainer");
        const context = {};

        $modalContainer.html(this._chooseFromTemplate, context).modal("show");

        this._enableChooseFromModalHandlers();

    }

    _drawSuggestionsModal() {

        function _onGetDataSuccess(response) {

            if (api.checkisValidResult(response)) {

                that._externalAssetsData.setCataloguePhotos(response.result.photos);

                const $modalContainer = $("#modalContainer");
                const context = {
                    photos: that._externalAssetsData.getCataloguePhotos()
                };

                $modalContainer.html(that._suggestionsTemplate(context)).modal("show");

                that._enableSuggestionsModalHandlers();

            }

        }

        const that = this;

        api.getRandomPhotos(this._externalAssetsData.getSuggestionsTerm(), this._externalAssetsData.getNumberOfSuggestions(), this._externalAssetsData.getDocumentType(), _onGetDataSuccess);

    }

    _drawCatalogueScreen() {

        const $quizWrapper = $(".quiz-wrapper");
        const context = {
            topics: this._externalAssetsData.getCatalogueTopics(),
            photos: this._externalAssetsData.getCataloguePhotos()
        };

        baseController.stackSimpleContent(this._catalogueTemplate, context);
        $quizWrapper.addClass("white-background");

        this._enableCatalogueScreenHandlers();
        this._disableChooseFromModalHandlers();

        goUpController.initialize();

    }

    initialize(isSuggestions, suggestionsTerm, documentType, onSelectImageCallback, onCancelImageCallback) {

        if (isSuggestions) {

            this._externalAssetsData.setSuggestionsTerm(suggestionsTerm);
            this._externalAssetsData.setDocumentType(documentType);
            this._drawSuggestionsModal();

        } else {
            this._drawChooseFromModal();
        }

        this._onSelectImageCallback = onSelectImageCallback;
        this._onCancelImageCallback = onCancelImageCallback;

    }

}